import { render, staticRenderFns } from "./offAtt.vue?vue&type=template&id=e818f220&scoped=true&"
import script from "./offAtt.vue?vue&type=script&lang=js&"
export * from "./offAtt.vue?vue&type=script&lang=js&"
import style0 from "./offAtt.vue?vue&type=style&index=0&id=e818f220&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e818f220",
  null
  
)

export default component.exports